export const FEATURE_FLAG_PREFER_UNIQUE_CODES = "preferUniqueCodes"
